<template>
    <div id="h5Body" class="chat h5 default"  v-bind:class="{  iframeH5: isIframe }">
        <Header></Header>
        <Body></Body>
        <Footer></Footer>
        <Popup
            style="width: 100%"
            :closeOnClickModal="false"
            v-model="evaluateModalFlag"
            position="bottom"
        >
            <Evaluate v-on:closePopup="close()"></Evaluate>
        </Popup>
        <Popup
            style="width: 100%"
            :closeOnClickModal="false"
            v-model="messageModalFlag"
            position="bottom"
        >
            <Message v-on:closePopup="close()"></Message>
        </Popup>
    </div>
</template>

<script>
    import language from "../../store/index";
    import Header from "./header";
    import Footer from "./footer";
    import Body from "./body";
    import {Popup} from "mint-ui";
    import Evaluate from "./evaluate";
    import Message from "./message";
    import urlParams from "../../api/urlParams";

    export default {
        name: "index",
        data() {
            return {
                title: "",
                evaluateModalFlag: "",
                messageModalFlag: "",
                isIframe: false,
            };
        },
        components: {
            Header,
            Body,
            Evaluate,
            Message,
            Footer,
            Popup,
        },
        mounted (){
            this.title = language.title;
            if (urlParams("from") === "iframe") {
                console.log('是否对接页面')
                this.isIframe = true;
            }
            document.querySelector(".chat").onclick = function (e) {
                const link = e.target.getAttribute('data-link')
                if (link) {
                    window.open(link)
                }
            };
        },
        methods: {
            close() {
                this.$store.dispatch("setConfigPc", [
                    {key: "messageModal", value: false},
                    {key: "evaluateModal", value: false},
                ]);
            },
        },
        watch: {
            evaluateModal() {
                this.evaluateModalFlag = this.$store.getters.getConfigPc.evaluateModal;
            },
            messageModal() {
                this.messageModalFlag = this.$store.getters.getConfigPc.messageModal;
            },
        },
        computed: {
            evaluateModal() {
                this.evaluateModalFlag = this.$store.getters.getConfigPc.evaluateModal;
            },
            messageModal() {
                this.messageModalFlag = this.$store.getters.getConfigPc.messageModal;
            },
        },
    };
</script>
<style scoped>
    .h5 {
        display: flex;
        flex-direction: column;
    }

    .body {
        flex: 1;
        background: antiquewhite;
    }
    #h5Body{
        overflow: hidden;
    }
</style>



// WEBPACK FOOTER //
// src/components/h5/index.vue